import React from 'react';
import { useIntl } from 'react-intl';
import { ImageNoDataToShow } from '@nxsys/assets/images';
import { StyledEmpty } from './index.styled';

type AppEmptyProps = {
  title?: string;
  isLoading?: boolean;
  imgPath?: string;
  description?: string;
  footer?: React.ReactNode;
};

const AppEmpty: React.FC<AppEmptyProps> = ({
  title,
  isLoading = false,
  imgPath = ImageNoDataToShow,
  description,
  footer,
}: AppEmptyProps) => {
  const { messages } = useIntl();
  return (
    <StyledEmpty>
      {!isLoading ? (
        <>
          <img src={imgPath} alt="empty" />
          <div className="font-[600] text-[19px] text-[#555A61] mt-[16px]">
            {title || `${messages['table.noDataToShow']}`}
          </div>
          {description && (
            <div className="font-[400] text-[15px] text-[#666666] mt-[16px] w-[460px] text-center">
              {description}
            </div>
          )}
          {footer && <div className="mt-[16px]">{footer}</div>}
        </>
      ) : null}
    </StyledEmpty>
  );
};
export default AppEmpty;
